export default __webpack_public_path__ + "static/media/Path3444.472839f4.svg";